// extracted by mini-css-extract-plugin
export default {"container":"container--l6iTu","icon":"icon--bQJGX"};